export default __webpack_public_path__ + "static/media/dataPreviewHide.24ae0878.svg";